import FileSaver from 'file-saver'

export const saveFile = (file, fileName) => FileSaver.saveAs(file, fileName)
